import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  label = 'This special launch offer ends in'
}: {
  label?: string;
}) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    unit: 'Hours'
  }, {
    value: pad(minutes),
    unit: 'Min'
  }, {
    value: pad(seconds),
    unit: 'Sec'
  }];
  return <div className="w-full rounded-2xl border border-alert-500/30 bg-alert-500/10 p-4" data-id="element-19" data-mp="10dmw5ewpi54u">
      <p className="flex items-center justify-center gap-2 text-center text-[11px] font-extrabold uppercase tracking-[0.14em] text-alert-600 sm:text-xs" data-id="element-20" data-mp="15adcm3cfb2qs">
        <ClockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-21" data-mp="t23g9qq041j9" />
        {label}
      </p>
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-22" data-mp="t091yv98j7o5">
        {blocks.map(block => <div key={block.unit} className="flex flex-col items-center" data-id="element-23" data-mp="12som9z8088c7">
            <span className="min-w-[62px] rounded-xl bg-navy-900 px-2 py-2 text-center text-3xl font-black tabular-nums text-white sm:min-w-[74px] sm:text-4xl" data-id="element-24" data-mp="f3dh85jmfrs9">
              {block.value}
            </span>
            <span className="mt-1 text-[10px] font-bold uppercase tracking-widest text-navy-600" data-id="element-25" data-mp="o3s439c8hexv">
              {block.unit}
            </span>
          </div>)}
      </div>
    </div>;
}